const $$splitComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout/login.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_rootLayout/login')({
  preload: false,
  loader: async () => {
    window.location.replace(`${process.env.PUBLIC_DREAMHAUS_URL}/login`);
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});